import React, { useState, useEffect, useCallback, KeyboardEvent } from "react"
import { observer } from "mobx-react"
import { FilterButtons, Table, TableProperty } from "../../components"
import { useStores } from "../../models/root-store"
import { CommonAttributes } from "eteva-types"
import { ContentModelType } from "../../models/content-store"
import { useTranslation } from "react-i18next"
import { SearchBar } from "../Layout/SearchBar"
import { makeStyles } from "@material-ui/styles"

const tableProperties: TableProperty<ContentModelType>[] = [
  { key: "title", title: "contents.title" },
  { key: "likes", title: "contents.likes" },
  { key: "dislikes", title: "contents.dislikes" },
  { key: "hits", title: "contents.hits" },
]

const useStyles = makeStyles({
  filterContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    margin: "26px 0",
  },
})

const filterButtons = [
  { value: true, label: "categories.activeFilter" },
  { value: false, label: "categories.inactiveFilter" },
]

export const ContentAnalytics: React.FC = observer(() => {
  const {
    contentStore: { contents, total, fetching, getAll },
  } = useStores()
  const { t } = useTranslation()
  const { filterContainer } = useStyles()
  const [search, setSearch] = useState("")
  const [selectedRadio, setSelectedRadio] = useState<boolean | undefined>()
  const [currentPage, setCurrentPage] = useState(0)
  const pageSize = 10

  const getAllContents = async (page = 0) => {
    if (!page) setCurrentPage(0)
    await getAll(page, pageSize, search, selectedRadio)
  }

  const memoizedGetContents = useCallback(getAllContents, [])

  useEffect(() => {
    memoizedGetContents()
  }, [memoizedGetContents])

  const onChangePage = (event: any, page: number) => {
    if (total > pageSize * page || page > -1) {
      setCurrentPage(page)
      getAll(page, pageSize, search, selectedRadio)
    }
  }

  const handleSearch = (e: KeyboardEvent<HTMLInputElement>) => {
    const searchQuery = (e.target as HTMLInputElement).value || ""
    setSearch(searchQuery)
    setCurrentPage(0)
    getAll(0, pageSize, searchQuery, selectedRadio)
  }

  const onRadioClick = (value: boolean) => {
    setSelectedRadio(value)
    setCurrentPage(0)
    getAll(0, pageSize, search, value)
  }

  const renderFilters = () => (
    <div className={filterContainer}>
      <FilterButtons
        onRadioClick={onRadioClick}
        buttons={filterButtons}
        selected={selectedRadio}
        defaultChecked="super"
      />
      <SearchBar width="100%" onChange={handleSearch} placeholder="categories.searchByName" />
    </div>
  )

  return (
    <>
      <h3>{t("sidebar.contents")}</h3>
      {renderFilters()}
      <Table<ContentModelType & CommonAttributes>
        hideCheckbox
        loading={fetching}
        total={total}
        page={currentPage}
        pageSize={pageSize}
        onChangePage={onChangePage}
        items={contents}
        properties={tableProperties}
      />
    </>
  )
})
